// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionMessages_root__31Az9"};